export const MEDIADESKTOP = 1200
export const MEDIATABLET = 768

export const ACCESS_TOKEN = '@react-boilerplate-access-token'

export const REFRESH_TOKEN = '@react-boilerplate-refresh-token'

export const actions = [
  { name: 'create_customers', label: 'Cadastrar Cliente' },
  { name: 'read_customers', label: 'Visualizar Clientes' },
  { name: 'update_customers', label: 'Editar Cliente' },
  { name: 'delete_customers', label: 'Apagar Clientes' },

  { name: 'create_employees', label: 'Cadastrar Funcionário' },
  { name: 'read_employees', label: 'Visualizar Funcionários' },
  { name: 'update_employees', label: 'Editar Funcionário' },
  { name: 'delete_employees', label: 'Apagar Funcionários' },

  { name: 'create_orders', label: 'Criar Ordem' },
  { name: 'read_orders', label: 'Visualizar Ordens' },
  { name: 'update_orders', label: 'Editar Ordens' },
  { name: 'delete_orders', label: 'Apagar Ordens' },

  { name: 'create_products', label: 'Cadastar Produto' },
  { name: 'read_products', label: 'Visualizar Produtos' },
  { name: 'update_products', label: 'Editar Produtos' },
  { name: 'delete_products', label: 'Apagar Produtos' },

  { name: 'create_roles', label: 'Criar Cargos' },
  { name: 'read_roles', label: 'Visualizar Cargos' },
  { name: 'update_roles', label: 'Editar Cargos' },
  { name: 'delete_roles', label: 'Apagar Cargos' },

  { name: 'module_order', label: 'Módulo de Pedidos' },
  { name: 'module_orders', label: 'Módulo da Cozinha' },
  { name: 'module_delivery', label: 'Módulo de Entregas' },
  { name: 'module_managerial', label: 'Módulo de Gerenciamento' }
]
